import React from "react";
import styled from "styled-components";
import { useActionReducer } from "../../../../../context/ActionProvider";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { riotProductSkin } from "../skins/riot-product/index";
import { Icon } from "../../../../../components/Icon";
import { ConsoleType } from "../../../functional/utils";
import { riotLionSkin } from "../skins/project-l";
const getBtnType = (title) => {
    if (!title) {
        return;
    }
    const lowercaseTitle = title.toLowerCase();
    if (lowercaseTitle.includes(ConsoleType.PLAYSTATION)) {
        return ConsoleType.PLAYSTATION;
    }
    if (lowercaseTitle.includes(ConsoleType.XBOX)) {
        return ConsoleType.XBOX;
    }
    return;
};
const StylableConsoleButtons = ({ buttons = [], onButtonClick, ...otherProps }) => {
    const { dispatchAction } = useActionReducer();
    const onClick = (type, action) => {
        if (onButtonClick && type) {
            onButtonClick(type);
        }
        else if (action) {
            dispatchAction(action);
        }
    };
    return (React.createElement("div", { className: "console-buttons", "data-testid": "mediapromo-links", ...otherProps }, buttons.map(({ title, accessibilityText, action }) => {
        const btnType = getBtnType(title);
        return title ? (React.createElement("a", { key: title, className: `variant-${btnType}`, "data-testid": `cta-${btnType}`, onClick: () => onClick(btnType, action), "aria-label": accessibilityText },
            React.createElement(Icon, { name: btnType ?? "", "data-testid": `${btnType}-icon` }),
            title)) : null;
    })));
};
export const ConsoleButtons = styled(StylableConsoleButtons) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: riotLionSkin,
})}
`;
//# sourceMappingURL=ConsoleButtons.js.map